<template>
	<div>

		<div class="filters-wrap">

            <template v-for="filterName in selectedCategory.filters">

                <template v-if="filterName === 'recommendation'">
                    <div class="filters-wrap__item">
                        <label class="c-search-form__title">Recommendation</label>
                        <multiselect
                            @input="resetArticleCount(); fetchItems();"
                            v-model="selectedRecommendation"
                            :options="recommendations"
                            track-by="id"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            label="name"
                            class="multiselect-light js-select-job-type"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                        </multiselect>
                    </div>
                </template>

                <template v-if="filterName === 'category'">
                    <div class="filters-wrap__item">
                        <label class="c-search-form__title" for="search">{{msg.search_category}}</label>
                        <multiselect
                            @input="resetArticleCount(); fetchItems();"
                            v-model="selectedCategory"
                            :options="categories"
                            track-by="id"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            label="name"
                            class="multiselect-light js-select-job-type"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                        </multiselect>
                    </div>
                </template>

                <template v-if="Object.keys(categoryGroups).indexOf(filterName) !== -1">
                    <div class="filters-wrap__item">
                        <label class="c-search-form__title" for="search">{{msg.search_category}}</label>
                        <multiselect
                            @input="resetArticleCount(); fetchItems();"
                            v-model="selectedCategory"
                            :options="categories.filter((cat) => categoryGroups[filterName].indexOf(cat.id) !== -1)"
                            track-by="id"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            label="name"
                            class="multiselect-light js-select-job-type"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                        </multiselect>
                    </div>
                </template>

                <template v-if="filterName === 'location'">
                    <div class="filters-wrap__item">
                        <label class="c-search-form__title">{{msg.search_location}}</label>
                        <multiselect
                            @input="resetArticleCount(); fetchItems();"
                            v-model="selectedLocation"
                            :options="locations"
                            track-by="id"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            label="name"
                            class="multiselect-light js-select-job-type"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                        </multiselect>
                    </div>
                </template>

                <template v-if="filterName === 'location_text'">
                    <div class="filters-wrap__item">
                        <label class="c-search-form__title" for="search">{{msg.search_location}}</label>
                        <input
                            :placeholder="msg.search_location"
                            class="c-search-form__input c-search-form__input--light c-search-form__input--small"
                            type="text"
                            v-model="searchFilter"
                            @input="resetArticleCount(); fetchItems();"
                            name="search"
                            id="search"
                        />
                    </div>
                </template>


            </template>





		</div>

		<div class="row">
			<div class="col-12 col-md-6 col-lg-12">
				<AccommodationSearchCard
					v-for="(accommodation, index) in data"
					:key="index"
					:accommodation="accommodation"
					:categories="categories"
				></AccommodationSearchCard>
				<div v-if="!data.length" class="col-md-12 text-center">
					<p>{{msg.search_noresults}}</p>
				</div>
				<div class="col-md-12 text-center">
					<a
						v-if="(data.length > articleCount - 1)"
						href="#"
						@click.prevent="loadMore"
						class="btn btn--load"
					>{{msg.btn_load_more}}</a>
				</div>
			</div>
		</div>
		<accommodation-modal v-if="showAccommodationModal"></accommodation-modal>
	</div>
</template>

<script>
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
	props:{
		lang:String
	},
	created() {

        console.log('WHERE TO EAT AND DRINK');


	    //TODO uncomment!
		/*this.categories[0].name = this.msg.search_select_all;
		this.categories[1].name = this.msg.search_gastro_categ_restaurants;
		this.categories[2].name = this.msg.search_gastro_categ_ffarm;
		this.categories[3].name = this.msg.search_gastro_categ_trade;
		this.categories[4].name = this.msg.search_gastro_categ_self_sufficient;
		this.categories[5].name = this.msg.search_gastro_categ_tasting_room;
		this.categories[6].name = this.msg.search_gastro_categ_winery;
		this.categories[7].name = this.msg.search_gastro_categ_olive_oil;
		this.categories[8].name = this.msg.search_gastro_categ_cheese;
		this.categories[9].name = this.msg.search_gastro_categ_tavern;*/

		/*const urlParams = new URLSearchParams(window.location.search);
		const categoryId = urlParams.get("category");

		if (categoryId) {
			const preselectedCategory = this.categories.find(cat => cat.id === categoryId);
			if (preselectedCategory) {
				this.selectedCategory = preselectedCategory;
			}
			else
			{
				this.selectedCategory = this.categories[0];
			}
		}
		else
		{
			this.selectedCategory = this.categories[0];
		}

		console.log('selectedCategory', this.selectedCategory);*/

        this.preselectFromUrlParams();

        if(typeof this.selectedCategory !== 'object')
            this.selectedCategory = this.categories[0];

		this.fetchItems();

	},
	data() {
		return {
			data: [],
			searchFilter: "",
            categoryGroups: {
			    all_category_group: ["", "restaurants", "farm", "holding", "trade", "selffarm", 'inn', 'cheese', 'oliveoil', 'winery', 'tasting'],
                main_category_group: ["", "restaurants", 'taverns', "farms"],
                farm_category_group: ["farms", "farm", "holding", "trade", "selffarm"],
                tavern_category_group: ['taverns', 'inn', 'cheese', 'oliveoil', 'winery', 'tasting']
            },
			categories: [
				{
					id: "",                             //type=x from url
					name: "Select All",
                    categories: [],
                    filters: ['recommendation', 'location_text', 'all_category_group'],
                    url: {
					    name: '',
                        value: ''
                    }
				},
				{
					id: "restaurants",
					name: "Restaurants",
                    categories: ["restaurants"],
                    filters: ['location_text', 'recommendation'],
                    url: {
                        name: 'type',
                        value: 'restaurants'
                    }
				},
				{
					id: "farm",
					name: "Family Farm",
                    categories: ["farm"],
                    filters: ['location'],
                    url: {
                        name: 'type',
                        value: 'family_farm'
                    }
				},
                {
                    id: "farms",
                    name: "All farms",
                    categories: ["farm", "holding", "trade", "selffarm"],
                    filters: ['location'],
                    url: {
                        name: 'type',
                        value: 'farm'
                    }
                },
				{
					id: "holding",
					name: "Agricultural Holding",
                    categories: ["holding"],
                    filters: ['location'],
                    url: {
                        name: 'categories',
                        value: 'holding'
                    }
				},
				{
					id: "trade",
					name: "Trade",
                    categories: ["trade"],
                    filters: ['location'],
                    url: {
                        name: 'category',
                        value: 'trade'
                    }
				},
				{
					id: "selffarm",
					name: "Self-Sufficient Family Farm",
                    categories: ["selffarm"],
                    filters: ['location'],
                    url: {
                        name: 'category',
                        value: 'selffarm'
                    }
				},
				{
					id: "tasting",
					name: "Tasting Room",
                    categories: ['tasting'],
                    filters: ['tavern_category_group'],
                    url: {
                        name: 'category',
                        value: 'tasting'
                    }
				},
				{
					id: "winery",
					name: "Winery (Wine Tasting Room)",
                    categories: ['winery'],
                    filters: ['tavern_category_group'],
                    url: {
                        name: 'category',
                        value: 'winery'
                    }
				},
				{
					id: "oliveoil",
					name: "Olive Oil Tasting Room",
                    categories: ['oliveoil'],
                    filters: ['tavern_category_group'],
                    url: {
                        name: 'category',
                        value: 'oliveoil'
                    }
				},
				{
					id: "cheese",
					name: "Cheese Tasting Room",
                    categories: ['cheese'],
                    filters: ['tavern_category_group'],
                    url: {
                        name: 'category',
                        value: 'cheese'
                    }
				},
				{
					id: "inn",
					name: "Traditional Inn / Tavern",
                    categories: ['inn'],
                    filters: ['tavern_category_group'],
                    url: {
                        name: 'type',
                        value: 'inn'
                    }
				},
                {
                    id: "taverns",
                    name: "All taverns",
                    categories: ['inn', 'cheese', 'oliveoil', 'winery', 'tasting'],
                    filters: ['tavern_category_group'],
                    url: {
                        name: 'type',
                        value: 'tavern'
                    }
                }

            ],
            recommendations: [
                {
                    id: '',
                    name: 'All',
                },
                {
                    id: 'gault_and_millau',
                    name: 'Gault&Millau',
                },
                {
                    id: 'michelin',
                    name: 'Michelin preporuka'
                },
                {
                    id: 'falstaff',
                    name: 'Falstaff',
                },
                {
                    id: 'jre',
                    name: 'JRE',
                },
                {
                    id: 'pag_na_meniju',
                    name: 'Pag na meniju',
                }
            ],
            locations: [
                {
                    id: '',
                    name: 'All',
                },
                {
                    id: 'Dugi Otok',
                    name: 'Dugi Otok',
                },
                {
                    id: 'Lički dio Zadarske županije',
                    name: 'Lički dio Zadarske županije',
                },
                {
                    id: 'Otoci Ugljan Pašman Drage',
                    name: 'Otoci Ugljan, Pašman i Drage',
                },
                {
                    id: 'Ravni kotari',
                    name: 'Ravni kotari',
                },
            ],
			selectedCategory: undefined,
            selectedRecommendation: undefined,
            selectedLocation: undefined,
			articleCount: 5,
			accommodationModal: false,
		};
	},
	components: {
		VueBootstrapTypeahead,
		Multiselect
	},
	computed: {
		...mapState({
			showAccommodationModal: state => state.showAccommodationModal,
			msg: state => state.msg
		})
	},
	methods: {
		fetchItems()
		{

		    let params = {
                limit: this.articleCount
            };


		    if(this.selectedCategory) {         //always needed
                //params.category = this.selectedCategory.id;

                params.categories = this.selectedCategory.categories;



                let catFilters = this.selectedCategory.filters;

                catFilters.forEach((filterName) => {

                    switch (filterName) {
                        case 'recommendation':
                            if(this.selectedRecommendation)
                                params.recommendation = this.selectedRecommendation.id;
                            break;
                        case 'location':
                            if(this.selectedLocation)
                                params.location = this.selectedLocation.id;
                            break;
                        case 'location_text':
                            if(this.searchFilter.trim())
                                params.location = this.searchFilter;
                            break;
                    }

                });


            } else {
                console.error('Error - no location selected!');
            }



		    console.log('PARAMS', params);

            this.adjustUrl();

			axios
				.get("/" + this.lang + "/xgastro", {
					params: params
				})
				.then( (response) => {

				    console.log('then');

					if (response.data.success) {
					    console.log('success');
						this.data = response.data.data;
					}
				})
				.catch(function (error)
				{
					// console.log(error);
				});
		},
        adjustUrl() {

            console.log('adjustUrl');

            let urlParams = new URLSearchParams();



            //let url = new URL(window.location.hostname);

            //console.log('url', url);

            /*Object.keys(params).forEach((groupName) => {
                //url.searchParams.append(groupName, params[groupName]);
                urlParams.set(groupName, params[groupName]);
            });*/

            if(this.selectedCategory) {
                urlParams.set(this.selectedCategory.url.name, this.selectedCategory.url.value);

                let catFilters = this.selectedCategory.filters;

                catFilters.forEach((filterName) => {

                    switch (filterName) {
                        case 'recommendation':
                            if(this.selectedRecommendation)
                                urlParams.set("recommendation", this.selectedRecommendation.id);
                            break;
                        case 'location':
                            if(this.selectedLocation)
                                urlParams.set("location", this.selectedLocation.id);
                            break;
                        case 'location_text':
                            if(this.searchFilter.trim())
                                urlParams.set("location", this.searchFilter);
                            break;
                    }

                });


            }


            console.log('after foreach');

            //let urlstr = url.toString();

            console.log('url adjusting', urlParams);

            let urlStr = window.location.origin + window.location.pathname + '?' + urlParams.toString();

            history.replaceState({}, document.title, urlStr);

        },
        preselectFromUrlParams() {
            const params = new URLSearchParams(window.location.search);

            console.log('preselectFromUrlParams', params.toString());



            for (const [key, value] of params.entries()) {

                this.categories.forEach((cat) => {

                    console.log('--> ', key, value, cat);

                    if(cat.url.name === key && cat.url.value === value) {
                        console.log('FOUND CATEG', cat);
                        this.selectedCategory = cat;
                    }

                });

            }


            console.log('for presel', params.get('recommendation'), params.get('location'));

            if(typeof params.get('recommendation') === 'string') {
                this.selectedRecommendation = this.recommendations.reduce((acc, rec) => {
                    let ret = acc;
                    if(rec.id === params.get('recommendation'))
                        ret = rec;
                    return ret;
                }, undefined);
            }


            if(typeof params.get('location') === 'string') {
                this.selectedLocation = this.locations.reduce((acc, loc) => {
                    let ret = acc;
                    console.log('loop', loc, loc.id, params.get('location'));
                    if(loc.id === params.get('location'))
                        ret = loc;
                    return ret;
                }, undefined);
            }


            console.warn('PRESELECTED', this.selectedCategory, this.selectedLocation, this.selectedRecommendation);


        },
		loadMore()
		{
			this.articleCount += 5;

			this.fetchItems();
		},
		resetArticleCount()
		{
		    console.log('resetArticleCount');
			if (this.searchFilter.length < 2)
			{
				this.articleCount = 5;
			}
		}
	}
};
</script>

<style lang="scss">

//temp multiselect styling
.multiselect-light {
	width: 100%;
	box-shadow: inset 0 0 0 1px #DFDFDF;
	background-color: #fff;
	border: none;
	margin-bottom: 22px;
	font-size: 16px;
	color: #1D1D1B;
	padding: 18px 16px;
	position: relative;

	@media (min-width: 992px) {
		margin-bottom: 0;
	}

	&--active {

	}

	.multiselect__content {
		background-color: #fff;
		margin: 0;
		overflow-y: auto;
		position: absolute;
		left: 0;
		right: 0;
		width: 100%;
		top: 100%;
		z-index: 16;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		padding-left: 0;
		list-style-type: none;
		-webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
	}

	.multiselect__element {
		background-color: #fff;
		margin: 0;
		min-width: 144px;
		overflow-y: auto;
		top: calc(100% + 20px);
		z-index: 10;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		padding-left: 0;
		list-style-type: none;
	}

	.multiselect__select {
		position: relative;

		&:before {
			position: absolute;
			right: 0;
			top: 65%;
			color: #1D1D1B;
			margin-top: 10px;
			border-style: solid;
			border-width: 6px 6px 0;
			border-color: #1D1D1B transparent transparent;
			content: "";
		}
	}

	.multiselect__option {
		font-size: 14px;
		font-size: 1.4rem;
		line-height: 1.28571em;
		font-weight: 400;
		color: #1D1D1B;
		background-color: #fff;
		padding: 20px;
		display: block;
		cursor: pointer;
		-webkit-transition: color 250ms ease-in-out, background-color 250ms ease-in-out;
		transition: color 250ms ease-in-out, background-color 250ms ease-in-out;

		&--highlight, --selected {
			background-color: #1d1d1b;
			color: #ebebeb;
			padding: 20px;
		}

	}
}


.filters-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	position: relative;
	z-index: 12;

	@media (min-width: 992px) {
		// flex-wrap: nowrap;
		gap: 30px;
		margin-bottom: 30px;
	}

	&__item {
		position: relative;
		// z-index: 2;
		flex-basis: 100%;

		@media (min-width: 992px) {
			// flex: 0 1 218px;
			flex: 0 1 calc(50% - 15px);
		}
	}

	&__item--small {
		@media (min-width: 992px) {
			flex: 0 0 144px;
		}
	}

	.c-search-form__input {
		height: 60px;

		@media (min-width: 992px) {
			margin-bottom: 0;
		}
	}

}

</style>

